import {Option, option} from "ts-option";
import {store} from "../../navigation/ReduxProvider";
import AssetCategory from "../../model/asset/AssetCategory";

/**
 * Get boiler unit category.
 * @returns {Option<AssetCategory>} boiler unit.
 */
export function getBoilerUnitCategory(): Option<AssetCategory> {
	const state = store.getState();
	const boilerCategoryId = state.settings.boilerUnitCategoryId.orNull;
	return option(
		state.assetCategory.assetCategories.getOrElse([]).filter(c => c.id === boilerCategoryId)[0]
	);
}

export function getAsset(assetId: string) {
	const asset = store.getState().asset.assets[assetId];
	return option(asset);
}
